import Header from "./Header";
import classes from "./Notifications.module.css";
import { useContext } from "react";
import DataContext from "../../store/DataContext";
import Notification from "./Notification";
const Notifications = () => {
  const {
    NotificationData,
    numberOfUnreadMessages,
  } = useContext(DataContext);
  return (
    <section className={classes.notifications}>
      <Header />
      <section
        className={classes.all_notification}
      >
        {NotificationData.map((data) => {
          return (
            <Notification
              key={data.name}
              {...data}
              numberOfUnreadMessages={
                numberOfUnreadMessages
              }
            />
          );
        })}
      </section>
    </section>
  );
};

export default Notifications;
